import { FC } from 'react';
import PostRowHeaderValueTitle from './PostRowHeaderValueTitle';
import { useTranslation } from 'react-i18next';

type Props = {};

const InstagramPostRowHeader: FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <div
      className="tw-flex tw-items-center tw-pb-2 tw-text-md tw-font-semibold"
      data-cy="insights_competition-analysis_post-performance-section-headings-instagram"
    >
      <span
        className="tw-w-[7%]"
        data-cy="insights_competition-analysis_post-performance-section-page"
      >
        {t('page')}
      </span>
      <span
        className="tw-w-[15%]"
        data-cy="insights_competition-analysis_post-performance-section-post"
      >
        {t('post')}
      </span>
      <div
        className="tw-flex tw-w-[78%] tw-items-center tw-justify-between"
        data-cy="insights_competition-analysis_post-performance-section-metrics-instagram"
      >
        <PostRowHeaderValueTitle>Interactions</PostRowHeaderValueTitle>
        <PostRowHeaderValueTitle>Comments</PostRowHeaderValueTitle>
        <PostRowHeaderValueTitle>Likes</PostRowHeaderValueTitle>
      </div>
    </div>
  );
};

export default InstagramPostRowHeader;
